/* eslint-disable no-shadow */
/**
 * Saves information about currently logged in user to state
 */
import merge from "lodash/merge";
import * as actionTypes from "../actions/actionTypes";

const _seenNotifications = JSON.parse(localStorage.seenNotifications ?? "{}");

export default function user(
  state = {
    isFetching: false,
    isFetched: false,
    id: 0,
    email: null,
    features: [],
    seenNotifications: _seenNotifications,
  },
  action
) {
  switch (action.type) {
    case actionTypes.FETCH_USER:
      return { ...state, isFetching: true };
    case actionTypes.FETCH_USER_SUCCESS:
    case actionTypes.EDIT_USER_PROFILE_SUCCESS:
    case actionTypes.EDIT_USER_AVATAR_SUCCESS: {
      const userData = action.response.entities.users[action.response.result.user];
      return { ...state, ...userData, isFetched: true, isFetching: false };
    }
    case actionTypes.FETCH_USER_FAILURE:
      return { isFetching: false };
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.SIGNUP_SUCCESS: {
      const userData = action.response.entities.users[action.response.result.user];
      return { ...state, ...userData };
    }
    case actionTypes.CREATE_SPACE_SUCCESS:
      return {
        ...state,
        spaces: [...state.spaces, action.response.result],
      };
    case actionTypes.DELETE_SPACE_SUCCESS:
      return {
        ...state,
        spaces: state.spaces.filter(spaceId => spaceId !== action.id),
      };
    case actionTypes.LEAVE_SPACE_SUCCESS:
      return {
        ...state,
        spaces: state.spaces.filter(spaceId => spaceId !== action.spaceId),
      };

    case actionTypes.SAVE_NOTIFICATION_SEEN_SUCCESS: {
      const data = { ...state.seenNotifications };
      if (action.spaceId) {
        merge(data, {
          [action.spaceId]: { [action.notificationId]: action.value },
        });
      } else {
        merge(data, { [action.notificationId]: action.value });
      }
      localStorage.seenNotifications = JSON.stringify(data);
      return merge({}, state, { seenNotifications: data });
    }
    case actionTypes.VERIFY_TOTP_SUCCESS: {
      return {
        ...state,
        mfa: { totp_enabled: true },
      };
    }
    case actionTypes.DELETE_TOTP_SUCCESS: {
      return {
        ...state,
        mfa: { totp_enabled: false },
      };
    }
    default:
      return state;
  }
}
